module.exports = __webpack_public_path__ + "img/symbol_8.6e1e90de.png";